document.addEventListener('DOMContentLoaded', () => {
   const items = document.querySelectorAll('.js-footer-nav .menu-item-has-children');
   const ngLinks = document.querySelectorAll('.js-footer-nav .no-register_block a');

   const removeStyles = (list) => {
       list.forEach(item => {
           item.children[0].classList.remove('is-opened');
           item.children[1].classList.remove('is-opened');
       });
   };

   items.forEach(item => {
       const link = item.children[0];
       const menu = item.children[1];

       link.addEventListener('click', (e) => {
           e.preventDefault();

           if (link.matches('.is-opened')) {
               link.classList.remove('is-opened');
               menu.classList.remove('is-opened');
           } else {
               removeStyles(items);
               link.classList.toggle('is-opened');
               menu.classList.toggle('is-opened');
           }
       });
   });

   // ng links
   ngLinks.forEach(link => link.addEventListener('click', (e) => e.preventDefault()));

   // payment
    const payment = $('.js-footer-payment');

    payment && payment.slick({
        dots: false,
        arrows: false,
        infinite: false,
        slidesToShow: 3,
        slidesToScroll: 1,
        mobileFirst: true,
        responsive: [
            {
                breakpoint: 440,
                settings: {
                    slidesToShow: 4,
                }
            },
            {
                breakpoint: 640,
                settings: {
                    slidesToShow: 5,
                }
            },
            {
                breakpoint: 1023,
                settings: {
                    slidesToShow: 6,
                }
            },
            {
                breakpoint: 1200,
                settings: 'unslick'
            }
        ]
    });
});
